import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { getDonutChartOptions } from 'config/highcharts'
import { sortdData } from 'utils/highcharts.utils'

Highcharts.setOptions({
  credits: { enabled: false }
})

const WorkersByGroupChart = ({ data, totalWorkers, onGroupClick = null }) => {
  const chartData = data.map(d => {
    return {
      name: d.groupName,
      y: parseInt(d.workerCount),
      groupData: d
    }
  })
  const total = chartData.reduce((sum, item) => sum + item.y, 0)
  const max = totalWorkers

  const chartOptions = getDonutChartOptions({
    data: sortdData(chartData),
    title: `${total}/${max} Workers`,
    onPointClick: onGroupClick
  })

  return (
    <div className='w-full h-96 min-h-[600px] p-6'>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  )
}

export default WorkersByGroupChart
